export function getReportLocalizationKey(value: string): string {
  if (!value.startsWith('ticket-')) {
    return value;
  }

  return value.replace(/-([a-z])/g, (_, character: string) => character.toUpperCase());
}

export function getReportCompareLocalizationKey(value: string): string {
  return value.startsWith('ticket-custom-field:')
    ? 'ticketCustomFields'
    : `reportCompareGroupItemType.${getReportLocalizationKey(value)}`;
}
